<div class="cmyk-wrap">
  <h3 class="cmyk-heading" *ngIf="heading">{{ heading }}</h3>

  <div class="cmyk-mixer" [style.--cmyk-thumb]="thumb">
    <!-- Four ink sliders, no boxes: lay cyan, magenta, yellow and key onto white paper. -->
    <div class="cmyk-controls">
      <div class="cmyk-control">
        <div class="cmyk-row">
          <label class="cmyk-label" for="cmyk-c">Cyan</label>
          <input id="cmyk-c" class="cmyk-slider" type="range" min="0" max="100" step="1"
                 [style.background]="cyanTrack"
                 [value]="cyan" (input)="onCyan( $any( $event.target ).value )" aria-label="Cyan ink">
        </div>
        <span class="cmyk-value">{{ cLabel }}%</span>
      </div>
      <div class="cmyk-control">
        <div class="cmyk-row">
          <label class="cmyk-label" for="cmyk-m">Magenta</label>
          <input id="cmyk-m" class="cmyk-slider" type="range" min="0" max="100" step="1"
                 [style.background]="magentaTrack"
                 [value]="magenta" (input)="onMagenta( $any( $event.target ).value )" aria-label="Magenta ink">
        </div>
        <span class="cmyk-value">{{ mLabel }}%</span>
      </div>
      <div class="cmyk-control">
        <div class="cmyk-row">
          <label class="cmyk-label" for="cmyk-y">Yellow</label>
          <input id="cmyk-y" class="cmyk-slider" type="range" min="0" max="100" step="1"
                 [style.background]="yellowTrack"
                 [value]="yellow" (input)="onYellow( $any( $event.target ).value )" aria-label="Yellow ink">
        </div>
        <span class="cmyk-value">{{ yLabel }}%</span>
      </div>
      <div class="cmyk-control">
        <div class="cmyk-row">
          <label class="cmyk-label" for="cmyk-k">Key (Black)</label>
          <input id="cmyk-k" class="cmyk-slider" type="range" min="0" max="100" step="1"
                 [style.background]="keyTrack"
                 [value]="key" (input)="onKey( $any( $event.target ).value )" aria-label="Key black ink">
        </div>
        <span class="cmyk-value">{{ kLabel }}%</span>
      </div>
    </div>

    <!-- The bare paper, and beside it the print with the four inks laid down. Drag any
         ink and the print darkens away from the white paper, which never changes. -->
    <div class="cmyk-results">
      <div class="cmyk-result">
        <div class="cmyk-swatch" [style.background]="paperHex"></div>
        <span class="cmyk-result-name">White Paper</span>
        <span class="cmyk-result-hex">{{ paperHex }}</span>
      </div>
      <div class="cmyk-result">
        <div class="cmyk-swatch" [style.background]="printHex"></div>
        <span class="cmyk-result-name">The Print</span>
        <span class="cmyk-result-hex">{{ printHex }}</span>
      </div>
    </div>

    <!-- The mix written as four ink percentages. The ink-coverage note always keeps its
         line so showing it never grows the panel. -->
    <div class="cmyk-reading">
      <span class="cmyk-reading-code">{{ cmykString }}</span>
      <span class="cmyk-reading-note" [class.is-visible]="heavy" [attr.aria-hidden]="!heavy">over 300% ink, heavier than most presses allow</span>
    </div>
  </div>
</div>
